import { v4 as uuid } from "uuid";

/**
 * Category Database can be added here.
 * You can add category of your wish with different attributes
 * */

export const categories = [
  {
    _id: "1166b875-f318-401a-b20a-e2b2fec3c0e4",
    categoryName: "Cartoon",
    description:
      "",
  },
  {
    _id: "913fb5f8-77fe-4341-94b8-8f8bf1e8e913",
    categoryName: "Sport",
    description:
      "",
  },
  {
    _id: "1c284595-3bf9-47ed-974a-36072e561467",
    categoryName: "Modern",
    description:
      "",
  },
  {
    _id: "58d9050c-6748-4de1-9ef8-c922ac88e0c5",
    categoryName: "Classic",
    description:
      "",
  },
];
